<template>
  <div id="info">
    <modal height="auto" classes="msg-modal" width="300px" :adaptive="true" name="message">{{msg}}</modal>

    <div class="info-page">
      <div class="card">
        <el-tooltip effect="dark" :content="$t('i18nView.locked')" placement="top-start">
          <i v-if="status === 3 && currentAccount !== account" class="iconfont icon-lock"></i>
        </el-tooltip>

        <div class="align-center">
          <img class="avatar" :src="avatar" alt />
        </div>
        <div class="align-center">
          <h3>EOS: {{account}}</h3>
          <h3>{{$t('i18nView.nickname')}}: {{title}}</h3>
        </div>
        <div class="social">
          <ul class="social-list">
            <li v-if="website">
              <el-tooltip class="item" effect="dark" :content="website" placement="top-start">
                <a target="_blank" :href="website">
                  <i class="icon ico-website"></i>
                </a>
              </el-tooltip>
            </li>
            <li v-if="telegram">
              <el-tooltip class="item" effect="dark" placement="top-start" :content="telegram">
                <a target="_blank" :href="'https://t.me/' + telegram">
                  <i class="icon ico-telegram"></i>
                </a>
              </el-tooltip>
            </li>
            <li v-if="twitter">
              <el-tooltip class="item" effect="dark" placement="top-start" :content="twitter">
                <a target="_blank" :href="'https://twitter.com/' + twitter">
                  <i class="icon ico-twitter"></i>
                </a>
              </el-tooltip>
            </li>
            <li v-if="wechat">
              <el-tooltip class="item" effect="dark" placement="top-start" :content="wechat">
                <i class="icon ico-wechat"></i>
              </el-tooltip>
            </li>
            <!-- <li v-if="website" class="icon ico-website"></li>
            <li v-if="facebook" class="icon ico-facebook"></li>
            <li v-if="telegram" class="icon ico-telegram"></li>
            <li v-if="twitter" class="icon ico-twitter"></li>
            <li v-if="wechat" class="icon ico-wechat"></li>-->
          </ul>
        </div>


        <p class="desc">{{desc}}</p>

        <div class="modifer">{{$t('i18nView.lastModifier')}}: {{modifier}}</div>
     
        <hr />

        <div  class="explorer-wrap">
        <span>
          {{$t('i18nView.viewInBrowser')}}:
        </span>
        
        <ul class="explorer-list">
          <li>
            <a target="_blank" :href="'https://eospark.com/account/' + this.account">
              <img class="explorer-logo" src="https://gz.bcebos.com/v1/tokenpocket/dapp/eospark_new.png" alt="">
            </a>
          </li>
          <li>
            <a target="_blank" :href="'https://bloks.io/account/' + this.account">
              <img class="explorer-logo" src="https://dapp.mytokenpocket.vip/dapp/bloks.png" alt="">
            </a>
          </li>
          <li>
            <a target="_blank" :href="'https://eosx.io/account/' + this.account">
              <img class="explorer-logo" src="https://tp-statics.cdn.bcebos.com/dapp/eosxxx.png" alt="">
            </a>
          </li>
        </ul>
        </div>
      </div>
      
    
      <el-button
        v-if="status !== 3 || account === currentAccount"
        class="edit-btn"
        type="primary"
        @click="goEdit()"
      >{{$t('i18nView.edit')}}</el-button>
    </div>
    <!-- <div v-else></div> -->
  </div>
</template>
<script>
import Info from "./info";
export default Info;
</script>


<style lang="less">
#info {
  h3 {
    margin: 8px 0;
    font-size: 16px;
    line-height: 1.5;
  }

  .align-center {
    text-align: center;
    margin: 20px 0;
  }

  .card {
    position: relative;
    margin: 0 16px 40px;
    padding: 40px 30px;
    background: #fff;
    box-shadow: 0px 2px 13px 0px rgb(228, 228, 228);
    border-radius: 10px;
  }

  .icon-lock {
    position: absolute;
    top: 20px;
    right: 30px;
    color: #999;
    padding: 4px;
    border-radius: 4px;
    background-color: #f1f1f1;
  }

  .social-list {
    min-width: 30px;
    min-height: 40px;
    margin-top: 20px;
    padding: 0;
    text-align: center;

    li {
      display: inline-block;
    }
  }

  hr {
    margin: 20px 0;
    border: none;
    border-bottom: 1px solid #f1f1f1;
  }

  .avatar {
    display: block;
    margin: 0 auto 20px;
    width: 96px;
    height: 96px;
    border-radius: 6px;
    background: #f1f1f1;
  }

  .edit-btn {
    display: block;
    width: 80%;
    margin: 0 auto;
  }
}

.explorer-wrap {
  font-size: 13px;

  span {
    vertical-align: middle;
  }
}

.explorer-list {
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: inline-block;
    margin-right: 12px;
  }

  .explorer-logo {
    width: 30px;
    height: 30px;
  }

}


.icon {
  width: 30px;
  height: 20px;
  display: inline-block;
  margin: 0 8px;
  // border: 1px solid #f1f1f1;
  border-radius: 4px;
  background-size: 100% 100%;
}

p.desc {
  font-size: 13px;
  color: #333;
  margin: 10px 0 30px;
}
.modifer {
  text-align: right;
  font-size: 12px;
  color: #999;
}
</style>
